import { selectMenu } from './chunk-67X7HZEW.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/modifierGroupsFactory.ts
var modifierGroupsFactoryCore = (modifierGroups, state) => {
  const currentMenu = selectMenu(state);
  const menuModifierGroups = currentMenu.modifierGroups;
  const menuModifierItems = currentMenu.modifierItems;
  const resultModifierGroups = Object.values(modifierGroups).map((modifierGroup) => {
    const menuModifierGroup = menuModifierGroups[modifierGroup.modifierGroupId];
    const data = menuModifierGroup ? {
      posName: menuModifierGroup.posName,
      description: menuModifierGroup.posName,
      multiselect: menuModifierGroup.multiselect,
      quantityMode: menuModifierGroup.quantityMode,
      modifierGroupPricingVersions: menuModifierGroup.modifierGroupPricingVersions,
      defaultModifierGroupPricingVersionId: modifierGroups[modifierGroup.modifierGroupId].defaultModifierGroupPricingVersionId,
      priceCalcMode: menuModifierGroup.priceCalcMode,
      defaultSelectionPrice: modifierGroups[modifierGroup.modifierGroupId].defaultSelectionPrice,
      hidePriceIfFree: menuModifierGroup.hidePriceIfFree,
      backgroundColor: menuModifierGroup.backgroundColor,
      textColor: menuModifierGroup.textColor
    } : {
      posName: "",
      description: "",
      multiselect: false,
      quantityMode: "Off" /* OFF */,
      modifierGroupPricingVersions: [],
      defaultModifierGroupPricingVersionId: null,
      priceCalcMode: "max",
      defaultSelectionPrice: 0,
      hidePriceIfFree: false,
      backgroundColor: null,
      textColor: null
    };
    const modifierGroupPricingVersions = Object.values(data.modifierGroupPricingVersions).length > 0 ? [
      Object.values(data.modifierGroupPricingVersions).map(
        (modifierGroupPricingVersion) => ({
          label: modifierGroupPricingVersion.name,
          value: modifierGroupPricingVersion.modifierGroupPricingVersionId
        })
      )
    ] : [];
    return __spreadProps(__spreadValues({}, modifierGroup), {
      posName: data.posName,
      multiselect: data.multiselect,
      quantityMode: data.quantityMode,
      description: data.description,
      defaultModifierGroupPricingVersionId: data.defaultModifierGroupPricingVersionId,
      modifierGroupPricingVersions,
      priceCalcMode: data.priceCalcMode,
      defaultSelectionPrice: data.defaultSelectionPrice,
      hidePriceIfFree: data.hidePriceIfFree,
      backgroundColor: data.backgroundColor,
      textColor: data.textColor
    });
  }).sort((a, b) => a.sortPriority - b.sortPriority);
  const resultModifierGroupsData = resultModifierGroups.map((modifierGroup) => {
    const modifierItems = Object.values(modifierGroup.modifierItems).map((modifierItem) => {
      const modifierName = menuModifierItems[modifierItem.modifierItemId] ? menuModifierItems[modifierItem.modifierItemId].name : "";
      return __spreadProps(__spreadValues({}, modifierItem), {
        name: modifierName,
        linesBefore: menuModifierGroups[modifierGroup.modifierGroupId].modifierItems[modifierItem.modifierItemId].linesBefore,
        spacesBefore: menuModifierGroups[modifierGroup.modifierGroupId].modifierItems[modifierItem.modifierItemId].spacesBefore
      });
    }).sort((a, b) => a.sortPriority - b.sortPriority).reduce((acc, mi) => __spreadProps(__spreadValues({}, acc), { [mi.modifierItemId]: mi }), {});
    return __spreadProps(__spreadValues({}, modifierGroup), {
      modifierItems
    });
  });
  return resultModifierGroupsData;
};

export { modifierGroupsFactoryCore };
